import { useCallback } from 'react'

import { type UseClickActionArgs } from '@src/hooks/useClickAction/useClickActionArgs'
import {
  useTrackSelectCta,
  useTrackSelectNavCta,
  useTrackSelectPencilBannerCta,
  useTrackSelectRailCta,
  useTrackSelectStickyFooterCta,
} from '@src/utils/analytics.util'

export const useTrackNavigate = ({ navigate }: { navigate?: UseClickActionArgs['navigate'] }) => {
  const trackSelectCta = useTrackSelectCta()
  const trackSelectNavCta = useTrackSelectNavCta()
  const trackSelectStickyFooterCta = useTrackSelectStickyFooterCta()
  const trackSelectPencilBannerCta = useTrackSelectPencilBannerCta()
  const trackSelectRailCta = useTrackSelectRailCta()

  const trackNavigate = useCallback(() => {
    if (navigate?.href) {
      switch (navigate.analyticsEvent) {
        case 'select cta':
          trackSelectCta({ 'cta url': navigate.href })
          break
        case 'select nav cta': {
          trackSelectNavCta({ 'cta url': navigate.href })
          break
        }
        case 'select sticky footer cta': {
          trackSelectStickyFooterCta({ 'cta url': navigate.href })
          break
        }
        case 'select pencil banner cta': {
          trackSelectPencilBannerCta({ 'cta url': navigate.href })
          break
        }
        case 'select rail cta': {
          trackSelectRailCta({ 'cta url': navigate.href })
          break
        }
      }
    }
  }, [
    navigate?.analyticsEvent,
    navigate?.href,
    trackSelectCta,
    trackSelectNavCta,
    trackSelectPencilBannerCta,
    trackSelectRailCta,
    trackSelectStickyFooterCta,
  ])

  return { trackNavigate }
}
